import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SETTINGS } from 'codefoxhucore';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from '../../services/api.service';
import { generateDeleteText } from '../../helpers/helper';

@Component({
  selector: 'app-productattributedelete',
  templateUrl: './productattributedelete.component.html',
  styleUrls: ['./productattributedelete.component.scss']
})
export class ProductattributedeleteComponent implements OnInit, AfterViewInit {

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  deleteText: string = generateDeleteText();
  deleteInput: string = null;

  productAttributeId: number;
  loading = false;
  precheckWarning: string = null;

  constructor(
    private apiService: ApiService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.productAttributeId = this.config.data.productAttributeId;
  }

  ngOnInit(): void {
    this.preCheck();
  }

  preCheck(): void {
    this.loading = true;
    SETTINGS.precheckInterceptorPrecheck = 'WARNING';
    this.apiService.deleteProductAttribute(this.productAttributeId).subscribe((rsp) => {
      if (rsp.precheckWarning !== undefined) {
        this.precheckWarning = rsp.precheckWarning;
      }
    }).add(() => {
      this.loading = false;
    });
  }

  delete(): void {
      this.loading = true;
      this.apiService.deleteProductAttribute(this.productAttributeId).subscribe(() => {
          this.close(true);
      }).add(() => {
          this.loading = false;
      });
  }

  close(result: boolean = false): void {
      this.ref.close(result);
  }

  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
  }
}
